function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3584.6245,
    y1: 4066.0847,
    x2: 1116.0828,
    y2: 1000.3106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_1_)"
    },
    d: "M2905.513,2857.054c-56.701,59.693-110.352,98.188-152.74,128.602 c-498.264,357.51-1087.842,253.297-1213.144,227.848c-185.032-37.581-542.694-110.224-801.278-414.313 c-391.215-460.061-330.297-1184.875-26.844-1663.334c55.506-87.518,348.707-573.266,944.635-651.164 c360.65-47.143,781.051,47.939,1085.494,303.002C3380.69,1323.095,3335.196,2404.698,2905.513,2857.054z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M506.801,1116.427c-1.538-0.581-2.683-1.998-2.811-3.713c-0.423-5.657-0.732-11.418-0.92-17.122 c-0.077-2.343,1.791-4.274,4.173-4.315c5.776-0.13,4.213,5.634,5.355,20.943c0.176,2.339-1.61,4.347-3.988,4.482 C507.976,1116.738,507.362,1116.639,506.801,1116.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M504.787,1042.25c1.057-10.849,2.568-21.786,4.489-32.509c0.413-2.302,2.65-3.81,4.998-3.37 c6.393,1.239,2.224,4.842-0.895,36.814c-0.227,2.33-2.334,4.007-4.707,3.749C506.267,1046.67,504.562,1044.55,504.787,1042.25z  M522.001,958.031c3.29-10.439,7.057-20.942,11.074-30.85c2.151-5.328,10.097-1.865,8.026,3.239 c-3.995,9.881-7.63,20.015-10.849,30.233c-0.702,2.23-3.119,3.448-5.396,2.724 C522.551,962.643,521.306,960.237,522.001,958.031z M556.185,879.223c5.352-9.475,11.159-18.856,17.263-27.887 c3.15-4.653,10.343,0.138,7.213,4.769c-5.98,8.848-11.671,18.041-16.914,27.322 C560.989,888.31,553.433,884.091,556.185,879.223z M606.621,815.156c-1.808-1.553-2.015-4.235-0.461-5.988 c7.233-8.169,14.898-16.158,22.778-23.744c4.052-3.899,10.137,2.208,6.088,6.106c-7.721,7.433-15.232,15.261-22.321,23.263 C611.154,816.55,608.424,816.711,606.621,815.156z M669.023,756.795c-1.454-1.878-1.102-4.536,0.788-5.938 c8.805-6.529,17.982-12.791,27.277-18.614c4.786-2.983,9.5,4.178,4.717,7.178c-9.108,5.706-18.102,11.841-26.728,18.238 C673.19,759.059,670.478,758.672,669.023,756.795z M744.741,714.452c-1.01-0.382-1.88-1.128-2.387-2.162 c-1.042-2.122-0.149-4.649,1.997-5.64c9.999-4.623,20.299-8.909,30.619-12.741c2.22-0.824,4.722,0.284,5.596,2.481 c0.87,2.194-0.221,4.639-2.439,5.464c-10.113,3.754-20.208,7.956-30.007,12.486 C747.02,714.847,745.804,714.853,744.741,714.452z M826.222,686.427c-1.291-0.488-2.332-1.568-2.694-2.981 c-0.584-2.281,0.817-4.567,3.126-5.107c10.757-2.515,21.758-4.642,32.697-6.319c2.348-0.365,4.582,1.22,4.982,3.54 c0.402,2.313-1.176,4.484-3.526,4.844c-10.718,1.644-21.497,3.729-32.036,6.194 C827.894,686.803,827.01,686.726,826.222,686.427z M909.233,671.541c-0.1-2.343,1.75-4.292,4.132-4.355 c11.078-0.292,22.328-0.151,33.435,0.414c5.721,0.307,5.373,8.762-0.318,8.474c-10.88-0.555-21.901-0.69-32.756-0.404 C911.35,675.733,909.333,673.888,909.233,671.541z M1185.751,763.709c-25.852-19.743-31.666-19.423-28.119-24.776 c1.291-1.953,3.959-2.473,5.965-1.181c9.333,6.046,18.546,12.536,27.385,19.285 C1195.52,760.5,1190.305,767.179,1185.751,763.709z M995.875,677.181c0.39-2.306,2.61-3.836,4.962-3.418 c10.939,1.943,21.955,4.333,32.743,7.107c5.545,1.427,3.472,9.632-2.065,8.207c-10.573-2.717-21.369-5.062-32.087-6.966 C997.049,681.686,995.489,679.463,995.875,677.181z M1112.43,718.657c-29.258-14.143-34.954-12.689-32.598-18.678 c1.494-3.798,6.096-2.378,5.578-2.356c10.393,4.078,20.733,8.597,30.733,13.427c2.153,1.041,3.064,3.586,2.039,5.685 C1117.202,718.741,1114.72,719.728,1112.43,718.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M1238.033,810.995c-9.912-10.588-16.064-14.175-11.941-18.215 c1.672-1.64,4.406-1.628,6.104,0.056c10.692,10.536,16.054,14.738,11.938,18.455 C1242.899,812.405,1239.658,812.724,1238.033,810.995z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M1353.479,1120.224c-1.726-0.652-2.916-2.347-2.813-4.246 c0.301-5.574,0.486-11.216,0.554-16.773c0.029-2.343,1.984-4.189,4.369-4.126c2.378,0.07,4.292,2.012,4.264,4.357 c-0.07,5.67-0.261,11.427-0.567,17.117c-0.126,2.337-2.158,4.104-4.538,3.945 C1354.304,1120.469,1353.877,1120.374,1353.479,1120.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M771.381,1476.524c-11.105-4.543-22.149-9.6-32.825-15.032c-2.131-1.083-2.99-3.646-1.918-5.724 c3.02-5.852,5.465-0.364,37.956,12.93c2.214,0.904,3.287,3.39,2.399,5.552C775.443,1478.025,770.862,1476.54,771.381,1476.524z  M823.863,1489.908c1.636-6.367,5.411-1.503,39.765,4.571c2.359,0.405,3.945,2.625,3.558,4.927 c-0.388,2.307-2.609,3.839-4.959,3.424c-11.756-2.078-23.61-4.678-35.231-7.727 C824.667,1494.489,823.286,1492.157,823.863,1489.908z M688.221,1431.469c-9.835-6.808-19.514-14.116-28.762-21.72 c-1.841-1.515-2.108-4.192-0.594-5.981c4.266-5.041,5.418,0.83,34.255,20.786c1.963,1.359,2.458,4.008,1.106,5.918 C692.872,1432.379,690.187,1432.824,688.221,1431.469z M919.041,1508.859c-1.686-0.637-2.868-2.269-2.819-4.134 c0.062-2.341,2.044-4.161,4.427-4.064c11.726,0.474,23.589,0.462,35.258-0.037c2.386-0.101,4.423,1.713,4.562,4.053 c0.141,2.343-1.675,4.322-4.054,4.424c-11.913,0.51-24.022,0.523-35.991,0.038 C919.94,1509.119,919.472,1509.022,919.041,1508.859z M1012.033,1502.463c-1.362-0.515-2.439-1.689-2.743-3.198 c-0.463-2.303,1.057-4.514,3.396-4.935c11.476-2.064,23.006-4.64,34.271-7.656c2.292-0.614,4.681,0.723,5.34,2.984 c0.657,2.262-0.666,4.592-2.955,5.205c-11.496,3.079-23.265,5.706-34.98,7.815 C1013.555,1502.823,1012.754,1502.735,1012.033,1502.463z M1101.046,1476.142c-1.057-0.399-1.961-1.2-2.453-2.302 c-0.963-2.157,0.025-4.647,2.204-5.562c10.71-4.491,21.356-9.487,31.642-14.852c2.094-1.088,4.713-0.293,5.857,1.779 c1.141,2.074,0.371,4.64-1.722,5.731c-10.496,5.473-21.359,10.571-32.289,15.155 C1103.216,1476.538,1102.06,1476.525,1101.046,1476.142z M1181.815,1431.284c-0.763-0.288-1.457-0.791-1.976-1.491 c-1.414-1.907-1.005-4.557,0.914-5.919c9.428-6.689,18.677-13.862,27.493-21.317c1.793-1.517,4.518-1.303,6.09,0.488 c1.571,1.785,1.391,4.462-0.403,5.979c-8.996,7.609-18.435,14.93-28.057,21.757 C1184.66,1431.643,1183.132,1431.782,1181.815,1431.284z M1249.112,1369.236c-5.064-4.395,0.897-5.274,21.542-32.794 c3.362-4.484,10.341,0.616,6.974,5.103c-7.043,9.389-14.589,18.595-22.428,27.356 C1253.644,1370.639,1250.922,1370.807,1249.112,1369.236z M1302.925,1294.967c-5.911-3.201-0.341-5.314,13.58-36.748 c2.258-5.096,10.196-1.641,7.924,3.483c-4.75,10.728-10.019,21.365-15.661,31.619 C1307.624,1295.399,1304.969,1296.094,1302.925,1294.967z M1338.282,1210.572c-2.088-0.789-3.269-3.027-2.657-5.161 c3.171-11.092,5.895-22.408,8.094-33.632c0.451-2.294,2.712-3.766,5.054-3.291c2.347,0.491,3.873,2.724,3.425,5.018 c-2.245,11.453-5.024,22.998-8.262,34.315c-0.641,2.246-3.022,3.528-5.319,2.862 C1338.502,1210.652,1338.391,1210.613,1338.282,1210.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M616.735,1369.456c-10.208-11.022-15.356-15.446-11.065-18.966 c4.463-3.665,6.96,2.017,17.409,13.307c1.618,1.746,1.506,4.428-0.245,5.99C621.082,1371.35,618.352,1371.2,616.735,1369.456z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176744819747371902170000006292244183697123972_",
    gradientUnits: "userSpaceOnUse",
    x1: 1060.3834,
    y1: 663.9564,
    x2: 798.8289,
    y2: 1524.0673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176744819747371902170000006292244183697123972_)"
    },
    d: "M663.93,1262.206l61.343-7.597 c18.689,21.984,41.034,41.251,66.522,56.757c2.393,59.15-1.632,63.467,4.691,65.574l70.696,23.552 c2.066,0.687,4.329,0.017,5.634-1.667l37.232-48.063c29.672,2.868,59.067,0.84,87.154-5.563l44.627,42.899 c1.565,1.503,3.912,1.88,5.845,0.938l66.177-32.24c1.934-0.942,3.028-2.996,2.724-5.113l-8.656-60.421 c22.085-18.04,41.348-39.717,56.739-64.538l61.9-0.23c2.172-0.008,4.077-1.369,4.746-3.389l22.892-69.145 c0.669-2.021-0.046-4.256-1.781-5.565l-49.465-37.329c2.471-29.126-0.038-58.054-6.977-85.764 c41.068-43.097,46.84-43.134,43.838-48.955c-34.282-63.709-32.329-69.132-39.046-68.302l-61.343,7.596 c-18.688-21.985-41.035-41.251-66.521-56.757c-2.391-59.114,1.634-63.465-4.69-65.575 c-70.642-22.193-72.329-27.053-76.331-21.884l-37.232,48.064c-29.671-2.87-59.067-0.842-87.154,5.561 c-43.927-40.525-44.504-46.744-50.471-43.836c-64.922,33.055-69.835,30.826-68.901,37.353l8.656,60.42 c-22.085,18.04-41.349,39.717-56.739,64.539c-59.087,1.432-64.559-2.695-66.647,3.62 c-21.417,68.808-26.461,70.669-21.111,74.709l49.465,37.33c-2.47,29.124,0.039,58.054,6.977,85.763 c-40.928,42.951-46.851,43.103-43.837,48.956C659.166,1257.613,657.212,1263.036,663.93,1262.206z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182498381154672935190000011363229453460337552_",
    gradientUnits: "userSpaceOnUse",
    x1: 1010.4213,
    y1: 738.8856,
    x2: 816.9214,
    y2: 1597.0162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182498381154672935190000011363229453460337552_)"
    },
    d: "M860.047,1079.361 c2.63-39.144,37.204-68.404,77.07-65.226c39.861,3.19,70.159,37.61,67.531,76.755c-2.633,39.143-37.205,68.404-77.071,65.228 l0,0C887.701,1152.939,857.417,1118.496,860.047,1079.361z M928.004,1149.774l0.04,0.015L928.004,1149.774z M936.265,1026.823 c-32.358-2.581-61.106,20.937-63.296,53.568c-2.162,32.149,22.717,60.438,55.461,63.039 c32.741,2.609,61.138-21.422,63.297-53.57C993.891,1057.662,968.948,1029.421,936.265,1026.823z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072981855812826254990000009063497968862506413_",
    gradientUnits: "userSpaceOnUse",
    x1: 1011.5339,
    y1: 739.1371,
    x2: 818.0336,
    y2: 1597.2698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072981855812826254990000009063497968862506413_)"
    },
    d: "M869.276,1254.641L869.276,1254.641 c-10.046-3.794-19.756-8.418-28.95-13.794c-2.765-1.616-3.9-4.909-2.832-7.742c0.128-0.339,0.286-0.669,0.478-0.99 c1.794-3.014,5.766-3.985,8.849-2.182c10.576,6.183,21.892,11.296,33.626,15.213l0,0 c88.409,29.451,183.454-15.047,215.353-99.496c0.815-2.156,1.587-4.34,2.319-6.547 c29.536-89.217-20.671-185.415-111.185-215.596c-90.39-30.113-188.17,17.072-217.672,106.043 c-17.531,52.967-2.209,88.509-4.269,93.962c-2.226,5.892-10.945,5.203-12.385-0.951c-7.87-33.617-6.119-69.875,6.828-104.154 c55.872-147.908,266.353-156.916,339.702-14.681c22.574,43.77,26.586,93.306,11.296,139.481 c-0.79,2.389-1.629,4.755-2.511,7.098c-16.197,42.894-47.819,77.475-89.725,97.892c-44.193,21.527-94.532,24.722-141.742,8.995 C874.046,1256.39,871.651,1255.538,869.276,1254.641z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M1230.707,805.945c-0.933-0.353-1.628-1.212-1.705-2.253c-0.256-3.432-0.444-6.927-0.558-10.387 c-0.047-1.422,1.086-2.593,2.532-2.617c3.504-0.079,2.556,3.418,3.249,12.706c0.107,1.419-0.977,2.637-2.419,2.719 C1231.42,806.134,1231.048,806.073,1230.707,805.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M1229.485,760.944c0.641-6.581,1.557-13.217,2.723-19.722c0.251-1.396,1.608-2.312,3.032-2.044 c3.878,0.752,1.349,2.938-0.543,22.334c-0.138,1.413-1.416,2.431-2.856,2.274 C1230.383,763.626,1229.349,762.34,1229.485,760.944z M1239.928,709.852c1.996-6.333,4.281-12.705,6.718-18.716 c1.305-3.233,6.125-1.131,4.869,1.965c-2.424,5.994-4.629,12.142-6.582,18.341c-0.426,1.353-1.892,2.092-3.274,1.653 C1240.262,712.65,1239.507,711.19,1239.928,709.852z M1260.667,662.042c3.247-5.748,6.77-11.439,10.473-16.918 c1.911-2.823,6.275,0.084,4.376,2.893c-3.628,5.368-7.08,10.945-10.261,16.575 C1263.58,667.555,1258.997,664.995,1260.667,662.042z M1291.264,623.175c-1.097-0.942-1.223-2.569-0.28-3.633 c4.388-4.956,9.038-9.802,13.819-14.405c2.458-2.365,6.15,1.339,3.694,3.704c-4.684,4.509-9.241,9.258-13.541,14.113 C1294.014,624.021,1292.358,624.119,1291.264,623.175z M1329.121,587.77c-0.882-1.14-0.668-2.752,0.478-3.602 c5.342-3.961,10.909-7.76,16.548-11.292c2.903-1.81,5.763,2.535,2.861,4.354c-5.526,3.461-10.981,7.183-16.215,11.065 C1331.649,589.143,1330.004,588.909,1329.121,587.77z M1375.056,562.082c-0.613-0.231-1.141-0.684-1.448-1.312 c-0.632-1.287-0.09-2.82,1.212-3.422c6.066-2.804,12.315-5.404,18.575-7.73c1.347-0.5,2.865,0.173,3.395,1.505 c0.528,1.331-0.134,2.815-1.48,3.315c-6.135,2.277-12.259,4.827-18.204,7.575 C1376.439,562.321,1375.701,562.326,1375.056,562.082z M1424.487,545.081c-0.783-0.296-1.414-0.951-1.635-1.808 c-0.354-1.384,0.495-2.77,1.897-3.099c6.526-1.526,13.2-2.816,19.836-3.833c1.424-0.222,2.78,0.74,3.022,2.148 c0.244,1.404-0.714,2.72-2.139,2.939c-6.502,0.998-13.041,2.262-19.435,3.757 C1425.502,545.308,1424.966,545.261,1424.487,545.081z M1474.847,536.049c-0.061-1.421,1.062-2.604,2.507-2.642 c6.721-0.177,13.545-0.092,20.284,0.251c3.471,0.186,3.26,5.316-0.193,5.141c-6.601-0.336-13.287-0.418-19.872-0.245 C1476.131,538.593,1474.907,537.473,1474.847,536.049z M1642.6,591.965c-15.684-11.977-19.211-11.783-17.059-15.031 c0.783-1.185,2.402-1.5,3.619-0.716c5.662,3.668,11.251,7.605,16.613,11.7C1648.526,590.018,1645.362,594.07,1642.6,591.965z  M1527.409,539.471c0.236-1.399,1.584-2.327,3.01-2.074c6.636,1.179,13.319,2.629,19.864,4.312 c3.364,0.866,2.106,5.843-1.253,4.979c-6.414-1.648-12.964-3.071-19.466-4.226 C1528.122,542.205,1527.175,540.856,1527.409,539.471z M1598.119,564.633c-17.75-8.58-21.205-7.698-19.776-11.331 c0.906-2.304,3.698-1.443,3.384-1.429c6.305,2.474,12.578,5.216,18.645,8.146c1.306,0.631,1.859,2.176,1.237,3.449 C1601.014,564.684,1599.508,565.283,1598.119,564.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M1674.317,620.651c-6.014-6.423-9.745-8.6-7.244-11.051c1.014-0.995,2.673-0.988,3.703,0.034 c6.486,6.392,9.74,8.941,7.243,11.196C1677.27,621.506,1675.303,621.7,1674.317,620.651z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M1744.354,808.248c-1.047-0.396-1.769-1.424-1.706-2.576c0.182-3.382,0.295-6.805,0.336-10.175 c0.018-1.421,1.204-2.542,2.65-2.503c1.442,0.042,2.603,1.22,2.587,2.643c-0.043,3.44-0.158,6.932-0.344,10.384 c-0.076,1.418-1.309,2.49-2.753,2.394C1744.854,808.397,1744.595,808.339,1744.354,808.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M1391.218,1024.401c-6.737-2.756-13.437-5.824-19.914-9.119 c-1.293-0.657-1.814-2.212-1.164-3.472c1.832-3.55,3.316-0.221,23.027,7.844c1.343,0.549,1.994,2.057,1.455,3.368 C1393.682,1025.313,1390.903,1024.411,1391.218,1024.401z M1423.057,1032.521c0.992-3.862,3.283-0.912,24.124,2.773 c1.431,0.246,2.393,1.592,2.159,2.989c-0.235,1.399-1.583,2.329-3.009,2.077c-7.132-1.26-14.323-2.838-21.374-4.688 C1423.544,1035.301,1422.706,1033.886,1423.057,1032.521z M1340.768,997.068c-5.967-4.13-11.839-8.564-17.449-13.177 c-1.117-0.919-1.279-2.543-0.36-3.628c2.588-3.058,3.287,0.503,20.781,12.61c1.191,0.825,1.491,2.432,0.671,3.59 C1343.589,997.62,1341.96,997.89,1340.768,997.068z M1480.797,1044.018c-1.023-0.386-1.74-1.376-1.71-2.508 c0.037-1.42,1.24-2.524,2.686-2.465c7.114,0.288,14.311,0.28,21.39-0.023c1.447-0.062,2.683,1.039,2.768,2.459 c0.085,1.421-1.016,2.622-2.459,2.684c-7.227,0.31-14.573,0.317-21.834,0.023 C1481.342,1044.176,1481.059,1044.117,1480.797,1044.018z M1537.212,1040.138c-0.826-0.312-1.479-1.025-1.664-1.94 c-0.281-1.397,0.641-2.738,2.06-2.994c6.962-1.252,13.957-2.815,20.791-4.645c1.391-0.372,2.84,0.439,3.24,1.811 c0.399,1.372-0.404,2.786-1.793,3.158c-6.974,1.868-14.114,3.462-21.221,4.741 C1538.135,1040.356,1537.649,1040.303,1537.212,1040.138z M1591.212,1024.17c-0.642-0.242-1.19-0.728-1.488-1.397 c-0.584-1.309,0.015-2.82,1.337-3.374c6.498-2.724,12.956-5.756,19.196-9.01c1.27-0.66,2.859-0.178,3.553,1.079 c0.692,1.258,0.225,2.815-1.044,3.477c-6.367,3.32-12.957,6.413-19.589,9.194 C1592.529,1024.41,1591.828,1024.402,1591.212,1024.17z M1640.212,996.956c-0.463-0.175-0.884-0.48-1.199-0.904 c-0.858-1.157-0.61-2.765,0.554-3.591c5.72-4.058,11.331-8.41,16.679-12.932c1.088-0.921,2.741-0.791,3.694,0.296 c0.953,1.083,0.844,2.707-0.245,3.627c-5.458,4.616-11.184,9.057-17.021,13.199 C1641.938,997.174,1641.011,997.258,1640.212,996.956z M1681.038,959.314c-3.072-2.666,0.544-3.2,13.069-19.895 c2.039-2.72,6.274,0.374,4.231,3.096c-4.273,5.696-8.851,11.281-13.606,16.596 C1683.788,960.166,1682.137,960.267,1681.038,959.314z M1713.684,914.258c-3.586-1.942-0.207-3.224,8.238-22.294 c1.37-3.091,6.185-0.995,4.807,2.113c-2.882,6.508-6.078,12.961-9.501,19.182 C1716.535,914.52,1714.925,914.942,1713.684,914.258z M1735.134,863.059c-1.266-0.478-1.983-1.836-1.612-3.131 c1.924-6.729,3.576-13.594,4.91-20.403c0.273-1.391,1.646-2.285,3.066-1.996c1.424,0.298,2.35,1.652,2.078,3.044 c-1.362,6.948-3.048,13.952-5.012,20.817c-0.389,1.363-1.833,2.141-3.227,1.736 C1735.268,863.107,1735.2,863.084,1735.134,863.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC4F9"
    },
    d: "M1297.4,959.448c-6.193-6.687-9.316-9.37-6.713-11.506c2.707-2.223,4.223,1.224,10.561,8.073 c0.981,1.059,0.914,2.686-0.149,3.634C1300.037,960.597,1298.38,960.506,1297.4,959.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043445170206925821760000003596481946637374135_",
    gradientUnits: "userSpaceOnUse",
    x1: 1584.4128,
    y1: 355.466,
    x2: 1438.5459,
    y2: 1014.3813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043445170206925821760000003596481946637374135_)"
    },
    d: "M1326.031,894.383l37.214-4.609 c11.338,13.337,24.894,25.025,40.356,34.432c1.452,35.884-0.99,38.503,2.846,39.781l42.888,14.288 c1.253,0.417,2.626,0.011,3.418-1.012l22.587-29.158c18.001,1.74,35.833,0.51,52.873-3.375l27.073,26.025 c0.949,0.912,2.373,1.14,3.546,0.569l40.147-19.558c1.173-0.572,1.837-1.817,1.653-3.102l-5.251-36.655 c13.398-10.944,25.084-24.095,34.422-39.153l37.552-0.139c1.318-0.005,2.473-0.831,2.879-2.056l13.888-41.948 c0.406-1.226-0.028-2.582-1.081-3.376l-30.009-22.646c1.499-17.67-0.023-35.219-4.233-52.029 c24.914-26.145,28.416-26.168,26.595-29.699c-20.798-38.65-19.613-41.94-23.688-41.436l-37.214,4.608 c-11.338-13.338-24.894-25.025-40.356-34.432c-1.451-35.862,0.991-38.502-2.845-39.782 c-42.856-13.463-43.879-16.412-46.307-13.276l-22.587,29.159c-18-1.741-35.833-0.511-52.873,3.374 c-26.649-24.585-26.999-28.358-30.619-26.594c-39.386,20.053-42.366,18.701-41.8,22.66l5.251,36.655 c-13.398,10.944-25.084,24.095-34.421,39.153c-35.846,0.869-39.166-1.635-40.432,2.196 c-12.993,41.743-16.053,42.872-12.807,45.323l30.008,22.647c-1.498,17.669,0.024,35.219,4.233,52.029 c-24.83,26.057-28.423,26.149-26.594,29.7C1323.141,891.597,1321.956,894.887,1326.031,894.383z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170261528963316263560000016516304084784780714_",
    gradientUnits: "userSpaceOnUse",
    x1: 1536.234,
    y1: 576.9051,
    x2: 1418.8452,
    y2: 1097.4995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170261528963316263560000016516304084784780714_)"
    },
    d: "M1445.008,783.458 c1.596-23.747,22.57-41.498,46.755-39.57c24.182,1.935,42.563,22.817,40.969,46.564c-1.597,23.747-22.571,41.498-46.756,39.571 l0,0C1461.785,828.095,1443.412,807.2,1445.008,783.458z M1486.234,826.175l0.024,0.009L1486.234,826.175z M1491.246,751.585 c-19.631-1.566-37.07,12.701-38.399,32.498c-1.312,19.503,13.781,36.665,33.646,38.243c19.863,1.583,37.09-12.996,38.4-32.499 C1526.205,770.294,1511.074,753.162,1491.246,751.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120525732221140352640000007849247923447014286_",
    gradientUnits: "userSpaceOnUse",
    x1: 1536.9089,
    y1: 577.0576,
    x2: 1419.5198,
    y2: 1097.6533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120525732221140352640000007849247923447014286_)"
    },
    d: "M1450.607,889.794L1450.607,889.794 c-6.094-2.302-11.985-5.107-17.563-8.368c-1.677-0.981-2.366-2.978-1.718-4.697c0.078-0.205,0.174-0.406,0.29-0.6 c1.088-1.829,3.498-2.417,5.368-1.324c6.416,3.751,13.281,6.853,20.399,9.229l0,0c53.634,17.867,111.295-9.128,130.646-60.36 c0.494-1.308,0.963-2.633,1.407-3.972c17.918-54.125-12.54-112.484-67.452-130.794 c-54.836-18.268-114.155,10.357-132.053,64.332c-10.635,32.133-1.34,53.695-2.59,57.003c-1.35,3.575-6.64,3.156-7.513-0.577 c-4.774-20.394-3.712-42.39,4.142-63.186c33.895-89.73,161.586-95.195,206.084-8.907c13.695,26.554,16.129,56.605,6.853,84.618 c-0.479,1.45-0.988,2.885-1.523,4.306c-9.826,26.022-29.01,47.001-54.432,59.387c-26.81,13.06-57.349,14.998-85.989,5.457 C1453.501,890.855,1452.047,890.338,1450.607,889.794z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073689260106269120130000007865477356336246439_",
    gradientUnits: "userSpaceOnUse",
    x1: 1441.5808,
    y1: 1985.854,
    x2: 1089.5349,
    y2: 3458.0476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073689260106269120130000007865477356336246439_)"
    },
    d: "M1455.937,2269.109h-387.82 c-27.181,0-52.276,19.809-52.276,33.55v841.87c0,13.74,25.095,27.266,52.276,27.266h387.82c27.181,0,58.639-13.525,58.639-27.266 v-841.87C1514.576,2288.918,1483.117,2269.109,1455.937,2269.109z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142879436365758941000000015137221554846283655_",
    gradientUnits: "userSpaceOnUse",
    x1: 815.1933,
    y1: 2423.8413,
    x2: 600.6451,
    y2: 3321.0442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142879436365758941000000015137221554846283655_)"
    },
    d: "M952.294,2577.808 c0-7.11-24.507-14.458-51.688-14.458H517.18c-27.181,0-51.457,7.348-51.457,14.458v580.165c0,7.11,24.276,13.821,51.457,13.821 h383.426c27.181,0,51.688-6.711,51.688-13.821V2577.808z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080165615520609806240000011058161174477962880_",
    gradientUnits: "userSpaceOnUse",
    x1: 3373.3196,
    y1: 528.8091,
    x2: 2193.9714,
    y2: 4717.7935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080165615520609806240000011058161174477962880_)"
    },
    d: "M3158.347,1200.297 c0-17.465-29.233-30.642-56.414-30.642H2713.78c-27.181,0-48.086,13.177-48.086,30.642v1934.714 c0,17.466,20.905,36.782,48.086,36.782h388.153c27.181,0,56.414-19.317,56.414-36.782V1200.297z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170278530381999395130000004906683590523397792_",
    gradientUnits: "userSpaceOnUse",
    x1: 1940.6865,
    y1: 2028.2544,
    x2: 1579.825,
    y2: 3537.3137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170278530381999395130000004906683590523397792_)"
    },
    d: "M2059.637,1924.165 c0-12.865-23.441-24.763-50.622-24.763h-383.426c-27.181,0-46.441,11.898-46.441,24.763v1222.907 c0,12.865,19.26,24.721,46.441,24.721h383.426c27.181,0,50.622-11.856,50.622-24.721V1924.165z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122712168384977003610000012051706266624142742_",
    gradientUnits: "userSpaceOnUse",
    x1: 2451.2751,
    y1: 1987.0842,
    x2: 2052.8999,
    y2: 3653.0183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122712168384977003610000012051706266624142742_)"
    },
    d: "M2605.548,1546.341 c0-14.437-21.527-24.04-48.708-24.04h-383.426c-27.181,0-48.355,9.603-48.355,24.04v1600.534 c0,14.437,21.174,24.919,48.355,24.919h383.426c27.181,0,48.708-10.482,48.708-24.919V1546.341z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119108841807695922790000004199771300315725982_",
    gradientUnits: "userSpaceOnUse",
    x1: 3151.3257,
    y1: 326.9124,
    x2: 1762.1893,
    y2: 5261.0537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119108841807695922790000004199771300315725982_)"
    },
    d: "M2573.915,1178.553l310.366-456.854 c9.012-13.266,27.847-13.407,37.042-0.279l319.975,456.854c11.009,15.718,0.242,37.816-18.425,37.816h-630.341 C2574.017,1216.09,2563.213,1194.306,2573.915,1178.553z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002365811195128764250000010958188692701872513_",
    gradientUnits: "userSpaceOnUse",
    x1: 2513.3796,
    y1: 2706.1572,
    x2: 2925.8542,
    y2: 2227.3926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000002365811195128764250000010958188692701872513_)"
    },
    cx: 2934.186,
    cy: 2217.722,
    r: 307.515
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041977178699508338470000005969799674281393294_",
    gradientUnits: "userSpaceOnUse",
    x1: 3158.9294,
    y1: 1878.199,
    x2: 1939.2312,
    y2: 3720.8152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000041977178699508338470000005969799674281393294_)"
    },
    cx: 2934.186,
    cy: 2217.722,
    r: 297.29
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2689.039,2101.047c-1.032,0-2.081-0.233-3.067-0.733c-3.363-1.695-4.712-5.798-3.014-9.161 c48.161-95.413,144.424-154.684,251.227-154.684c17.041,0,34.111,1.535,50.732,4.566c3.707,0.676,6.164,4.229,5.488,7.932 c-0.673,3.71-4.236,6.138-7.932,5.488c-15.818-2.884-32.063-4.346-48.288-4.346c-101.624,0-193.221,56.4-239.052,147.191 C2693.934,2099.679,2691.533,2101.047,2689.039,2101.047z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -711.446 2730.8159)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 2940.663,
    cy: 2224.199,
    rx: 251.619,
    ry: 251.619
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065036306532146212320000017925507795699554223_",
    gradientUnits: "userSpaceOnUse",
    x1: 3122.5442,
    y1: 1930.9957,
    x2: 2473.0806,
    y2: 3021.3374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065036306532146212320000017925507795699554223_)"
    },
    d: "M2915.972,2411.256v-27.374 c-28.538-1.143-56.764-7.878-76.812-16.654c-7.158-3.134-10.808-11.168-8.751-18.707l6.955-25.499 c2.551-9.354,12.724-14.193,21.666-10.445c19.886,8.337,44.442,14.933,70.92,14.933c27.486,0,47.984-9.319,47.984-28.42 c0-17.237-15.839-27.486-54.041-37.734c-54.506-14.907-93.642-38.669-93.642-86.653c0-43.329,31.682-76.405,86.654-85.255 v-27.378c0-8.808,7.141-15.95,15.95-15.95h16.084c8.808,0,15.95,7.141,15.95,15.95v24.581 c26.406,1.057,45.628,5.572,60.883,10.933c7.815,2.746,12.086,11.166,9.918,19.161l-6.396,23.582 c-2.466,9.094-12.186,14.075-20.999,10.742c-14.044-5.311-33.901-10.841-59.713-10.841c-32.612,0-41.928,13.509-41.928,25.622 c0,14.908,19.566,25.156,61.96,38.203c60.565,18.168,85.721,43.325,85.721,88.515c0,41.463-30.747,78.733-90.378,88.052v30.636 c0,8.809-7.142,15.951-15.95,15.951h-16.086C2923.113,2427.207,2915.972,2420.065,2915.972,2411.256z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073688915543695456210000000819613519130002869_",
    gradientUnits: "userSpaceOnUse",
    x1: 2956.897,
    y1: 2560.8176,
    x2: 2896.7756,
    y2: 2847.3706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073688915543695456210000000819613519130002869_)"
    },
    d: "M3231.832,2726.451H2636.54 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.292c2.007,0,3.634,1.627,3.634,3.634v107.506 C3235.465,2724.825,3233.838,2726.451,3231.832,2726.451z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114031488368132561280000014382526691095125120_",
    gradientUnits: "userSpaceOnUse",
    x1: 2957.3701,
    y1: 2690.4038,
    x2: 2897.2488,
    y2: 2976.9565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114031488368132561280000014382526691095125120_)"
    },
    d: "M3232.304,2856.038h-595.291 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.291c2.007,0,3.634,1.627,3.634,3.634v107.506 C3235.938,2854.411,3234.311,2856.038,3232.304,2856.038z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021101032163003085800000018279386680067626668_",
    gradientUnits: "userSpaceOnUse",
    x1: 2957.8433,
    y1: 2819.99,
    x2: 2897.7219,
    y2: 3106.5427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021101032163003085800000018279386680067626668_)"
    },
    d: "M3232.777,2985.624h-595.291 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.291c2.007,0,3.634,1.627,3.634,3.634v107.506 C3236.411,2983.997,3234.784,2985.624,3232.777,2985.624z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043427758221962254130000014987668005341248152_",
    gradientUnits: "userSpaceOnUse",
    x1: 2958.3164,
    y1: 2946.2227,
    x2: 2898.1951,
    y2: 3232.7754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043427758221962254130000014987668005341248152_)"
    },
    d: "M3233.251,3111.856h-595.291 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.291c2.007,0,3.634,1.627,3.634,3.634v107.506 C3236.885,3110.229,3235.258,3111.856,3233.251,3111.856z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091005917687449840290000000974077615918509730_",
    gradientUnits: "userSpaceOnUse",
    x1: 2958.7893,
    y1: 3072.4553,
    x2: 2898.668,
    y2: 3359.0078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091005917687449840290000000974077615918509730_)"
    },
    d: "M3233.723,3238.089h-595.291 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.291c2.007,0,3.634,1.627,3.634,3.634v107.506 C3237.357,3236.462,3235.73,3238.089,3233.723,3238.089z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155105069918025985060000013614425933934090886_",
    gradientUnits: "userSpaceOnUse",
    x1: 1860.6083,
    y1: 2842.4502,
    x2: 2273.0828,
    y2: 2363.6855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000155105069918025985060000013614425933934090886_)"
    },
    cx: 2281.415,
    cy: 2354.015,
    r: 307.515
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026860444000867630690000007100419823031065749_",
    gradientUnits: "userSpaceOnUse",
    x1: 2506.158,
    y1: 2014.4919,
    x2: 1286.4601,
    y2: 3857.1077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000026860444000867630690000007100419823031065749_)"
    },
    cx: 2281.415,
    cy: 2354.015,
    r: 297.29
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2036.267,2237.339c-1.032,0-2.081-0.233-3.067-0.733c-3.364-1.695-4.712-5.798-3.014-9.161 c48.158-95.41,144.424-154.681,251.227-154.681c17.054,0,34.125,1.535,50.732,4.563c3.707,0.676,6.164,4.229,5.488,7.932 c-0.676,3.71-4.229,6.164-7.933,5.488c-15.805-2.881-32.053-4.343-48.288-4.343c-101.624,0-193.225,56.4-239.052,147.188 C2041.163,2235.97,2038.762,2237.339,2036.267,2237.339z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -999.0121 2309.156)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 2287.892,
    cy: 2360.492,
    rx: 251.619,
    ry: 251.619
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059289920732778635660000011052851777737459334_",
    gradientUnits: "userSpaceOnUse",
    x1: 2469.7729,
    y1: 2067.2886,
    x2: 1820.3091,
    y2: 3157.6309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059289920732778635660000011052851777737459334_)"
    },
    d: "M2263.2,2547.549v-27.374 c-28.537-1.143-56.764-7.878-76.812-16.654c-7.159-3.134-10.808-11.168-8.751-18.707l6.954-25.499 c2.552-9.354,12.725-14.193,21.667-10.444c19.886,8.336,44.442,14.932,70.919,14.932c27.486,0,47.985-9.319,47.985-28.42 c0-17.236-15.839-27.485-54.041-37.733c-54.507-14.908-93.642-38.669-93.642-86.653c0-43.329,31.682-76.405,86.654-85.255 v-27.378c0-8.808,7.142-15.95,15.95-15.95h16.084c8.808,0,15.951,7.142,15.951,15.95v24.581 c26.406,1.056,45.628,5.572,60.883,10.933c7.815,2.746,12.086,11.165,9.918,19.161l-6.395,23.582 c-2.466,9.094-12.186,14.075-20.999,10.742c-14.044-5.311-33.901-10.841-59.712-10.841c-32.612,0-41.928,13.509-41.928,25.622 c0,14.908,19.566,25.156,61.961,38.203c60.565,18.168,85.721,43.325,85.721,88.515c0,41.463-30.747,78.733-90.378,88.052 v30.636c0,8.809-7.142,15.95-15.951,15.95h-16.085C2270.341,2563.5,2263.2,2556.358,2263.2,2547.549z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072976617474473291250000006751929913013470628_",
    gradientUnits: "userSpaceOnUse",
    x1: 2304.1257,
    y1: 2683.697,
    x2: 2244.0044,
    y2: 2970.2498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072976617474473291250000006751929913013470628_)"
    },
    d: "M2579.06,2849.331h-595.291 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.291c2.007,0,3.634,1.627,3.634,3.634v107.506 C2582.694,2847.704,2581.067,2849.331,2579.06,2849.331z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081624900947452336480000012234778059005392806_",
    gradientUnits: "userSpaceOnUse",
    x1: 2304.5986,
    y1: 2813.2832,
    x2: 2244.4773,
    y2: 3099.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081624900947452336480000012234778059005392806_)"
    },
    d: "M2579.533,2978.917h-595.291 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.291c2.007,0,3.634,1.627,3.634,3.633v107.506 C2583.167,2977.29,2581.54,2978.917,2579.533,2978.917z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066493021809049277640000010907036538311506063_",
    gradientUnits: "userSpaceOnUse",
    x1: 2305.072,
    y1: 2942.8691,
    x2: 2244.9507,
    y2: 3229.4219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066493021809049277640000010907036538311506063_)"
    },
    d: "M2580.006,3108.503h-595.291 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.291c2.007,0,3.634,1.627,3.634,3.634v107.506 C2583.64,3106.876,2582.013,3108.503,2580.006,3108.503z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096027894996920527530000009157480655199603903_",
    gradientUnits: "userSpaceOnUse",
    x1: 2305.5449,
    y1: 3072.4553,
    x2: 2245.4236,
    y2: 3359.0081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096027894996920527530000009157480655199603903_)"
    },
    d: "M2580.479,3238.089h-595.291 c-2.007,0-3.634-1.627-3.634-3.634v-107.506c0-2.007,1.627-3.634,3.634-3.634h595.291c2.007,0,3.634,1.627,3.634,3.634v107.506 C2584.113,3236.462,2582.486,3238.089,2580.479,3238.089z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE41A4"
    },
    d: "M859.984,2958.589c-1.423,0-2.838-0.601-3.833-1.77c-2.919-3.432-5.808-6.884-8.662-10.354 c-1.763-2.145-1.456-5.315,0.691-7.08c2.147-1.763,5.317-1.454,7.08,0.691c2.818,3.427,5.67,6.833,8.554,10.222 c1.8,2.117,1.544,5.292-0.571,7.092C862.296,2958.196,861.137,2958.589,859.984,2958.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE41A4"
    },
    d: "M834.789,2927.437c-1.51,0-3.001-0.676-3.992-1.967c-5.44-7.082-10.815-14.334-15.978-21.553 c-1.616-2.26-1.094-5.402,1.166-7.018c2.263-1.616,5.402-1.095,7.018,1.166c5.096,7.128,10.403,14.287,15.772,21.278 c1.693,2.202,1.279,5.361-0.925,7.052C836.936,2927.098,835.859,2927.437,834.789,2927.437z M803.791,2884.07 c-1.629,0-3.227-0.789-4.197-2.248c-4.945-7.452-9.803-15.063-14.44-22.621c-1.452-2.368-0.711-5.464,1.659-6.917 c2.368-1.454,5.466-0.712,6.918,1.657c4.573,7.455,9.368,14.964,14.247,22.316c1.536,2.315,0.904,5.436-1.41,6.974 C805.712,2883.798,804.746,2884.07,803.791,2884.07z M775.919,2838.635c-1.755,0-3.46-0.92-4.385-2.558 c-4.393-7.778-8.688-15.724-12.765-23.615c-1.276-2.468-0.308-5.502,2.16-6.777c2.471-1.28,5.502-0.309,6.777,2.16 c4.021,7.781,8.256,15.614,12.588,23.284c1.366,2.42,0.513,5.487-1.906,6.854 C777.607,2838.424,776.756,2838.635,775.919,2838.635z M751.45,2791.279c-1.89,0-3.699-1.069-4.555-2.892 c-3.799-8.081-7.483-16.328-10.953-24.514c-1.086-2.558,0.11-5.51,2.667-6.594c2.556-1.085,5.51,0.108,6.594,2.667 c3.421,8.067,7.052,16.197,10.796,24.16c1.182,2.515,0.102,5.51-2.412,6.692C752.894,2791.125,752.167,2791.279,751.45,2791.279z  M730.654,2742.206c-2.032,0-3.945-1.24-4.706-3.252c-3.159-8.344-6.186-16.857-9.001-25.3c-0.879-2.636,0.545-5.485,3.18-6.363 c2.646-0.883,5.485,0.545,6.363,3.18c2.774,8.318,5.757,16.703,8.867,24.923c0.984,2.599-0.326,5.502-2.924,6.484 C731.846,2742.101,731.246,2742.206,730.654,2742.206z M713.802,2691.645c-2.183,0-4.193-1.433-4.829-3.635 c-2.484-8.598-4.814-17.331-6.921-25.953c-0.66-2.7,0.992-5.421,3.691-6.081c2.698-0.66,5.42,0.994,6.081,3.691 c2.076,8.49,4.369,17.086,6.813,25.55c0.771,2.669-0.766,5.458-3.435,6.229C714.735,2691.581,714.266,2691.645,713.802,2691.645z  M701.142,2639.883c-2.348,0-4.447-1.652-4.927-4.041c-1.754-8.734-3.345-17.632-4.729-26.443 c-0.431-2.744,1.444-5.318,4.189-5.751c2.756-0.422,5.32,1.446,5.751,4.189c1.362,8.673,2.928,17.429,4.654,26.023 c0.547,2.725-1.218,5.376-3.941,5.922C701.803,2639.851,701.469,2639.883,701.142,2639.883z M692.889,2587.242 c-2.526,0-4.704-1.899-4.992-4.47c-0.981-8.75-1.791-17.755-2.41-26.759c-0.19-2.771,1.903-5.173,4.675-5.363 c2.746-0.196,5.173,1.904,5.363,4.675c0.607,8.86,1.405,17.717,2.371,26.326c0.31,2.761-1.678,5.25-4.439,5.559 C693.266,2587.232,693.076,2587.242,692.889,2587.242z M689.208,2534.08c-2.71,0-4.947-2.158-5.025-4.886 c-0.193-6.75-0.292-13.648-0.292-20.502c0-2.107,0.01-4.22,0.028-6.335c0.024-2.764,2.271-4.988,5.029-4.988 c0.015,0,0.029,0,0.044,0c2.779,0.025,5.01,2.296,4.988,5.073c-0.018,2.089-0.028,4.172-0.028,6.25 c0,6.759,0.097,13.56,0.288,20.214c0.079,2.777-2.107,5.092-4.884,5.173C689.306,2534.08,689.257,2534.08,689.208,2534.08z  M689.66,2480.779c-0.074,0-0.149-0.002-0.226-0.005c-2.775-0.123-4.925-2.472-4.803-5.248c0.39-8.822,0.943-17.833,1.644-26.78 c0.218-2.769,2.607-4.831,5.408-4.623c2.769,0.218,4.839,2.638,4.622,5.408c-0.693,8.834-1.24,17.728-1.624,26.439 C694.563,2478.67,692.336,2480.779,689.66,2480.779z M693.826,2427.63c-0.187,0-0.375-0.01-0.565-0.031 c-2.762-0.309-4.75-2.797-4.441-5.557c0.986-8.816,2.133-17.766,3.411-26.605c0.396-2.749,2.939-4.668,5.697-4.259 c2.749,0.396,4.657,2.947,4.259,5.697c-1.261,8.732-2.394,17.576-3.368,26.284C698.53,2425.73,696.352,2427.63,693.826,2427.63z  M701.446,2374.864c-0.292,0-0.586-0.026-0.884-0.079c-2.734-0.485-4.56-3.095-4.076-5.831c1.551-8.752,3.263-17.61,5.089-26.33 c0.571-2.72,3.245-4.457,5.955-3.892c2.72,0.57,4.462,3.236,3.892,5.955c-1.806,8.616-3.497,17.371-5.03,26.022 C705.961,2373.148,703.839,2374.864,701.446,2374.864z M712.374,2322.723c-0.391,0-0.791-0.047-1.189-0.144 c-2.7-0.653-4.357-3.373-3.702-6.073c2.093-8.634,4.356-17.358,6.723-25.932c0.74-2.679,3.506-4.256,6.188-3.509 c2.677,0.739,4.249,3.509,3.509,6.188c-2.34,8.47-4.575,17.093-6.645,25.624C716.702,2321.179,714.642,2322.723,712.374,2322.723 z M726.558,2271.382c-0.495,0-0.997-0.073-1.495-0.228c-2.653-0.825-4.134-3.645-3.311-6.297 c2.646-8.508,5.462-17.078,8.371-25.47c0.91-2.626,3.774-4.015,6.401-3.106c2.625,0.91,4.015,3.776,3.106,6.401 c-2.875,8.29-5.657,16.756-8.269,25.162C730.689,2269.999,728.703,2271.382,726.558,2271.382z M744.022,2221.028 c-0.599,0-1.21-0.108-1.803-0.336c-2.594-0.997-3.887-3.908-2.89-6.5c3.208-8.348,6.589-16.72,10.05-24.882 c1.084-2.559,4.044-3.751,6.594-2.667c2.558,1.084,3.753,4.036,2.667,6.594c-3.416,8.058-6.754,16.323-9.921,24.564 C747.951,2219.8,746.045,2221.028,744.022,2221.028z M764.845,2171.935c-0.712,0-1.434-0.152-2.122-0.473 c-2.518-1.172-3.607-4.166-2.433-6.684c3.789-8.13,7.755-16.25,11.786-24.134c1.264-2.473,4.293-3.455,6.769-2.189 c2.473,1.264,3.453,4.295,2.188,6.767c-3.976,7.778-7.887,15.786-11.626,23.806 C768.554,2170.86,766.74,2171.935,764.845,2171.935z M1207.638,2146.244c-4.834,0-9.692-0.383-14.439-1.14 c-2.744-0.437-4.614-3.016-4.177-5.759c0.437-2.746,3.031-4.608,5.759-4.177c8.172,1.302,16.621,1.348,25.035,0.133 c2.743-0.385,5.299,1.513,5.697,4.262c0.395,2.749-1.513,5.3-4.262,5.697C1216.714,2145.913,1212.134,2146.244,1207.638,2146.244 z M1246.091,2138.029c-1.953,0-3.813-1.146-4.629-3.059c-1.089-2.554,0.098-5.51,2.654-6.601 c7.553-3.222,15.043-7.436,22.257-12.525c2.269-1.603,5.41-1.059,7.01,1.21c1.601,2.271,1.059,5.41-1.21,7.01 c-7.794,5.497-15.906,10.059-24.111,13.559C1247.419,2137.898,1246.749,2138.029,1246.091,2138.029z M1168.705,2137.071 c-0.745,0-1.5-0.167-2.214-0.516c-8.012-3.935-15.813-9.104-23.188-15.366c-2.119-1.798-2.377-4.973-0.58-7.09 c1.798-2.121,4.974-2.376,7.09-0.58c6.743,5.726,13.846,10.437,21.111,14.003c2.494,1.225,3.522,4.239,2.299,6.733 C1172.35,2136.037,1170.562,2137.071,1168.705,2137.071z M789.141,2124.445c-0.832,0-1.675-0.208-2.453-0.644 c-2.425-1.357-3.288-4.423-1.931-6.846c4.393-7.845,8.968-15.649,13.596-23.191c1.451-2.369,4.55-3.111,6.918-1.659 c2.369,1.454,3.111,4.55,1.659,6.92c-4.559,7.429-9.066,15.117-13.396,22.845 C792.613,2123.517,790.903,2124.445,789.141,2124.445z M1289.568,2107.758c-1.282,0-2.563-0.486-3.543-1.461 c-1.971-1.957-1.983-5.141-0.026-7.113c5.967-6.011,11.599-12.643,16.739-19.713c1.631-2.245,4.773-2.744,7.028-1.11 c2.246,1.634,2.743,4.78,1.11,7.028c-5.443,7.483-11.41,14.509-17.738,20.884 C1292.153,2107.262,1290.861,2107.758,1289.568,2107.758z M1128.069,2103.257c-1.467,0-2.921-0.639-3.915-1.868 c-3.213-3.974-6.383-8.262-9.42-12.747c-2.125-3.139-4.207-6.392-6.186-9.669c-1.438-2.377-0.675-5.47,1.703-6.906 c2.379-1.434,5.471-0.673,6.907,1.703c1.891,3.131,3.879,6.237,5.906,9.232c2.879,4.249,5.878,8.308,8.914,12.064 c1.747,2.16,1.411,5.327-0.75,7.074C1130.297,2102.892,1129.179,2103.257,1128.069,2103.257z M817.056,2078.972 c-0.964,0-1.94-0.277-2.802-0.854c-2.306-1.551-2.918-4.677-1.369-6.982c5.012-7.455,10.221-14.856,15.485-21.999 c1.649-2.237,4.796-2.71,7.034-1.064c2.235,1.649,2.712,4.798,1.064,7.034c-5.177,7.024-10.303,14.306-15.233,21.642 C820.266,2078.193,818.675,2078.972,817.056,2078.972z M1320.669,2064.733c-0.735,0-1.48-0.162-2.184-0.503 c-2.502-1.208-3.55-4.216-2.341-6.717c3.717-7.694,6.615-15.781,8.614-24.037c0.655-2.702,3.383-4.355,6.073-3.706 c2.7,0.655,4.359,3.373,3.706,6.073c-2.168,8.948-5.308,17.71-9.335,26.045 C1324.333,2063.686,1322.537,2064.733,1320.669,2064.733z M1100.438,2057.835c-1.911,0-3.737-1.094-4.582-2.946 c-3.72-8.167-7.046-16.692-9.885-25.333c-0.866-2.639,0.571-5.482,3.211-6.35c2.633-0.865,5.479,0.57,6.348,3.209 c2.723,8.294,5.913,16.469,9.481,24.301c1.153,2.528,0.038,5.511-2.491,6.663 C1101.844,2057.689,1101.135,2057.835,1100.438,2057.835z M848.737,2036.041c-1.112,0-2.232-0.367-3.163-1.122 c-2.158-1.75-2.491-4.917-0.742-7.075c5.682-7.01,11.55-13.908,17.447-20.504c1.85-2.071,5.034-2.248,7.102-0.398 c2.071,1.85,2.25,5.03,0.398,7.101c-5.787,6.476-11.55,13.25-17.129,20.134C851.655,2035.404,850.202,2036.041,848.737,2036.041z  M1333.085,2013.314c-0.038,0-0.074,0-0.111-0.002c-2.777-0.061-4.979-2.361-4.919-5.138c0.016-0.789,0.025-1.577,0.025-2.366 c-0.002-7.756-0.789-15.492-2.34-22.991c-0.563-2.72,1.186-5.382,3.907-5.944c2.713-0.575,5.381,1.185,5.944,3.907 c1.69,8.167,2.548,16.587,2.549,25.026c0,0.863-0.008,1.726-0.028,2.587C1338.053,2011.133,1335.813,2013.314,1333.085,2013.314z  M1083.819,2007.296c-2.324,0-4.413-1.621-4.916-3.985c-1.873-8.814-3.298-17.845-4.233-26.842 c-0.286-2.762,1.721-5.235,4.483-5.523c2.761-0.274,5.235,1.722,5.525,4.483c0.897,8.646,2.266,17.322,4.066,25.789 c0.578,2.718-1.158,5.389-3.874,5.967C1084.519,2007.26,1084.167,2007.296,1083.819,2007.296z M884.293,1996.285 c-1.279,0-2.556-0.483-3.537-1.454c-1.975-1.953-1.993-5.138-0.039-7.113c6.32-6.392,12.859-12.665,19.431-18.644 c2.053-1.872,5.237-1.721,7.105,0.336c1.87,2.055,1.719,5.236-0.336,7.105c-6.442,5.86-12.85,12.01-19.048,18.277 C886.887,1995.787,885.59,1996.285,884.293,1996.285z M1322.314,1961.584c-1.896,0-3.71-1.077-4.563-2.908 c-1.526-3.28-3.237-6.52-5.086-9.631c-2.494-4.195-5.245-8.307-8.177-12.217c-1.667-2.222-1.215-5.376,1.007-7.043 c2.219-1.664,5.376-1.217,7.043,1.007c3.147,4.197,6.099,8.609,8.776,13.114c2.021,3.401,3.889,6.941,5.557,10.522 c1.172,2.52,0.082,5.512-2.437,6.684C1323.747,1961.432,1323.025,1961.584,1322.314,1961.584z M923.744,1960.443 c-1.462,0-2.913-0.634-3.907-1.859c-1.752-2.155-1.425-5.323,0.732-7.075c6.741-5.479,13.692-10.813,20.663-15.858l0.745-0.535 c2.261-1.613,5.404-1.084,7.015,1.179c1.611,2.263,1.084,5.403-1.179,7.015l-0.681,0.491 c-6.82,4.935-13.622,10.155-20.219,15.516C925.981,1960.075,924.859,1960.443,923.744,1960.443z M1078.313,1954.376 c-0.002,0-0.002,0-0.003,0c-2.779-0.002-5.028-2.256-5.027-5.033c0.007-8.976,0.483-18.1,1.413-27.117 c0.285-2.764,2.748-4.766,5.521-4.486c2.762,0.286,4.771,2.757,4.487,5.521c-0.897,8.677-1.354,17.455-1.361,26.089 C1083.341,1952.127,1081.088,1954.376,1078.313,1954.376z M966.983,1929.327c-1.668,0-3.301-0.828-4.259-2.345 c-1.482-2.35-0.781-5.456,1.569-6.939c7.63-4.816,15.452-9.413,23.248-13.664c2.437-1.331,5.497-0.431,6.825,2.009 c1.33,2.438,0.431,5.493-2.008,6.823c-7.611,4.149-15.246,8.637-22.695,13.34C968.83,1929.077,967.9,1929.327,966.983,1929.327z  M1290.663,1919.116c-1.218,0-2.441-0.441-3.407-1.333c-6.204-5.72-13.06-11.026-20.379-15.775 c-2.33-1.511-2.995-4.627-1.482-6.957c1.513-2.33,4.629-2.992,6.957-1.482c7.794,5.056,15.102,10.715,21.722,16.819 c2.043,1.883,2.173,5.065,0.288,7.106C1293.371,1918.571,1292.019,1919.116,1290.663,1919.116z M1013.756,1903.849 c-1.901,0-3.72-1.084-4.57-2.923c-1.164-2.523-0.064-5.512,2.458-6.676c8.205-3.789,16.577-7.308,24.887-10.461 c2.592-0.981,5.502,0.321,6.487,2.918c0.986,2.597-0.321,5.502-2.918,6.488c-8.091,3.07-16.246,6.499-24.239,10.19 C1015.179,1903.7,1014.462,1903.849,1013.756,1903.849z M1083.757,1901.447c-0.334,0-0.673-0.034-1.014-0.103 c-2.721-0.558-4.477-3.216-3.92-5.937c1.043-5.094,2.243-10.214,3.584-15.315c-5.811,1.398-11.642,2.967-17.416,4.685 c-2.661,0.788-5.464-0.725-6.257-3.388c-0.791-2.664,0.725-5.464,3.388-6.255c7.766-2.31,15.636-4.359,23.431-6.099 c0.85-2.597,3.627-4.041,6.25-3.242c2.658,0.812,4.153,3.625,3.34,6.281c-2.561,8.374-4.735,16.903-6.464,25.35 C1088.193,1899.804,1086.097,1901.447,1083.757,1901.447z M1246.22,1890.109c-0.691,0-1.392-0.144-2.062-0.445 c-7.706-3.47-15.895-6.495-24.34-8.994c-2.664-0.788-4.185-3.588-3.398-6.25c0.788-2.664,3.588-4.185,6.25-3.398 c8.881,2.628,17.501,5.813,25.619,9.469c2.531,1.141,3.661,4.12,2.52,6.651 C1249.972,1889.006,1248.139,1890.109,1246.22,1890.109z M1195.295,1874.899c-0.28,0-0.562-0.025-0.845-0.072 c-8.392-1.42-17.114-2.405-25.93-2.929c-2.772-0.165-4.886-2.548-4.722-5.322c0.167-2.772,2.549-4.881,5.322-4.722 c9.174,0.547,18.262,1.574,27.007,3.054c2.739,0.463,4.585,3.059,4.121,5.798 C1199.832,1873.162,1197.703,1874.899,1195.295,1874.899z M1115.623,1873.871c-2.492,0-4.657-1.85-4.983-4.388 c-0.354-2.756,1.592-5.276,4.347-5.631c9.047-1.164,18.129-1.926,26.998-2.266c2.8-0.075,5.114,2.058,5.22,4.834 c0.106,2.777-2.058,5.114-4.834,5.22c-8.569,0.328-17.35,1.066-26.1,2.191 C1116.054,1873.858,1115.838,1873.871,1115.623,1873.871z M1099.265,1850.535c-0.63,0-1.272-0.12-1.893-0.372 c-2.572-1.046-3.812-3.98-2.766-6.555c3.345-8.23,7.129-16.512,11.244-24.615c1.259-2.476,4.282-3.462,6.762-2.207 c2.477,1.258,3.465,4.285,2.207,6.763c-3.989,7.853-7.653,15.878-10.894,23.849 C1103.133,1849.351,1101.251,1850.535,1099.265,1850.535z M1123.314,1803.035c-0.892,0-1.795-0.236-2.612-0.734 c-2.373-1.446-3.124-4.541-1.68-6.913c4.593-7.537,9.595-15.12,14.873-22.537c1.61-2.263,4.75-2.795,7.015-1.182 c2.263,1.609,2.794,4.75,1.182,7.015c-5.138,7.223-10.01,14.604-14.476,21.938 C1126.667,1802.177,1125.01,1803.035,1123.314,1803.035z M1154.292,1759.768c-1.159,0-2.322-0.398-3.271-1.21 c-2.109-1.808-2.355-4.983-0.547-7.092c5.913-6.903,12.21-13.51,18.714-19.634c2.022-1.908,5.209-1.808,7.11,0.213 c1.906,2.022,1.809,5.205-0.213,7.11c-6.243,5.88-12.29,12.225-17.971,18.857 C1157.118,1759.172,1155.71,1759.768,1154.292,1759.768z M1192.979,1723.394c-1.528,0-3.036-0.693-4.025-2.008 c-1.668-2.22-1.222-5.374,0.999-7.044c7.133-5.361,14.719-10.445,22.549-15.109c2.381-1.423,5.474-0.64,6.895,1.747 c1.423,2.386,0.64,5.474-1.747,6.895c-7.521,4.482-14.806,9.363-21.652,14.509 C1195.093,1723.065,1194.032,1723.394,1192.979,1723.394z M1238.595,1696.11c-1.886,0-3.694-1.066-4.552-2.885 c-1.186-2.514-0.11-5.51,2.402-6.695c7.914-3.733,16.061-7.17,24.913-10.506c2.603-0.983,5.502,0.332,6.482,2.931 c0.979,2.6-0.334,5.502-2.933,6.483c-8.598,3.24-16.503,6.574-24.17,10.19C1240.044,1695.954,1239.313,1696.11,1238.595,1696.11z  M1288.349,1677.153c-2.145,0-4.133-1.384-4.802-3.54c-0.824-2.654,0.66-5.472,3.313-6.296c7.684-2.386,15.876-4.752,25.781-7.45 c2.681-0.735,5.446,0.851,6.175,3.532c0.73,2.68-0.851,5.444-3.532,6.175c-9.788,2.666-17.872,5.002-25.441,7.352 C1289.347,1677.08,1288.844,1677.153,1288.349,1677.153z M1339.727,1662.905c-2.227,0-4.262-1.49-4.86-3.745 c-0.711-2.685,0.891-5.439,3.576-6.15c8.234-2.179,17.031-4.542,25.565-7.057c2.671-0.781,5.462,0.74,6.247,3.404 c0.784,2.664-0.739,5.461-3.404,6.247c-8.652,2.549-17.528,4.933-25.833,7.133 C1340.586,1662.849,1340.152,1662.905,1339.727,1662.905z M1390.734,1647.45c-2.035,0-3.949-1.243-4.709-3.258 c-0.979-2.6,0.334-5.502,2.934-6.481c8.909-3.357,16.644-6.831,23.651-10.624c2.44-1.318,5.495-0.414,6.818,2.03 c1.321,2.443,0.413,5.495-2.03,6.818c-7.409,4.01-15.552,7.671-24.892,11.19 C1391.923,1647.346,1391.322,1647.45,1390.734,1647.45z M1437.007,1621.692c-1.428,0-2.847-0.604-3.841-1.778 c-1.796-2.12-1.533-5.295,0.588-7.09c6.596-5.589,12.179-11.66,17.068-18.563c1.605-2.268,4.744-2.807,7.011-1.199 c2.268,1.605,2.805,4.745,1.199,7.011c-5.309,7.498-11.627,14.37-18.778,20.427 C1439.309,1621.301,1438.155,1621.692,1437.007,1621.692z M1467.534,1578.894c-0.639,0-1.289-0.123-1.916-0.382 c-2.569-1.059-3.792-4-2.733-6.568c3.199-7.758,6.293-15.824,9.454-24.66c0.935-2.617,3.813-3.981,6.43-3.041 c2.615,0.935,3.977,3.815,3.041,6.43c-3.216,8.986-6.363,17.199-9.625,25.105 C1471.385,1577.721,1469.51,1578.894,1467.534,1578.894z M1485.616,1528.766c-0.511,0-1.03-0.079-1.542-0.244 c-2.644-0.852-4.099-3.684-3.247-6.329c2.715-8.433,5.327-16.898,7.902-25.369c0.807-2.657,3.617-4.159,6.276-3.348 c2.657,0.809,4.157,3.619,3.349,6.276c-2.592,8.523-5.22,17.039-7.951,25.523 C1489.716,1527.406,1487.741,1528.766,1485.616,1528.766z M1501.255,1477.806c-0.483,0-0.976-0.07-1.462-0.218 c-2.657-0.807-4.159-3.615-3.353-6.275c2.589-8.529,5.207-17.046,7.922-25.526c0.85-2.648,3.688-4.095,6.324-3.258 c2.646,0.847,4.105,3.678,3.259,6.324c-2.698,8.434-5.304,16.901-7.876,25.382 C1505.407,1476.406,1503.413,1477.806,1501.255,1477.806z M1517.642,1427.092c-0.558,0-1.126-0.093-1.683-0.292 c-2.618-0.93-3.987-3.807-3.057-6.423c3.201-9.012,6.329-17.227,9.558-25.12c1.053-2.571,3.994-3.797,6.561-2.749 c2.571,1.053,3.802,3.989,2.749,6.561c-3.168,7.743-6.24,15.814-9.387,24.674 C1521.65,1425.805,1519.712,1427.092,1517.642,1427.092z M1537.921,1377.866c-0.735,0-1.48-0.162-2.186-0.503 c-2.502-1.21-3.548-4.218-2.34-6.72c4.008-8.287,8.261-16.318,12.641-23.872c1.392-2.405,4.469-3.224,6.875-1.829 c2.404,1.394,3.222,4.472,1.829,6.875c-4.256,7.337-8.388,15.145-12.289,23.206 C1541.584,1376.82,1539.79,1377.866,1537.921,1377.866z M1564.703,1331.873c-0.997,0-2.002-0.295-2.882-0.91 c-2.274-1.595-2.828-4.73-1.233-7.007c5.189-7.404,10.748-14.624,16.525-21.455c1.795-2.119,4.966-2.389,7.09-0.593 c2.12,1.795,2.386,4.968,0.593,7.09c-5.582,6.599-10.954,13.574-15.968,20.731 C1567.848,1331.126,1566.288,1331.873,1564.703,1331.873z M1599.074,1291.273c-1.302,0-2.604-0.503-3.589-1.506 c-1.947-1.981-1.917-5.166,0.066-7.113c4.749-4.663,9.748-9.251,14.858-13.64c1.752-1.505,3.516-2.988,5.287-4.454 c2.14-1.77,5.312-1.467,7.082,0.673c1.77,2.142,1.469,5.312-0.673,7.082c-1.723,1.423-3.437,2.867-5.141,4.331 c-4.943,4.244-9.775,8.68-14.365,13.186C1601.619,1290.793,1600.346,1291.273,1599.074,1291.273z M1640.088,1257.296 c-1.582,0-3.139-0.743-4.118-2.135c-1.6-2.273-1.053-5.41,1.218-7.008c7.401-5.207,15.048-10.144,22.729-14.671 c2.397-1.41,5.482-0.614,6.887,1.778c1.411,2.394,0.616,5.477-1.778,6.887c-7.45,4.392-14.868,9.181-22.048,14.233 C1642.097,1257,1641.087,1257.296,1640.088,1257.296z M1685.973,1230.29c-1.873,0-3.671-1.051-4.537-2.852 c-1.204-2.504-0.149-5.51,2.354-6.713c8.174-3.928,16.551-7.514,24.902-10.655c2.602-0.978,5.502,0.336,6.479,2.936 c0.979,2.6-0.336,5.502-2.936,6.479c-8.076,3.037-16.179,6.505-24.086,10.307 C1687.447,1230.13,1686.705,1230.29,1685.973,1230.29z M1735.803,1211.586c-2.211,0-4.236-1.469-4.848-3.704 c-0.734-2.679,0.845-5.446,3.524-6.18c8.758-2.397,17.668-4.38,26.48-5.895c2.726-0.47,5.34,1.369,5.81,4.107 c0.47,2.738-1.369,5.338-4.107,5.81c-8.493,1.459-17.081,3.37-25.527,5.682 C1736.691,1211.527,1736.244,1211.586,1735.803,1211.586z M1788.255,1202.603c-2.62,0-4.829-2.029-5.014-4.681 c-0.192-2.772,1.898-5.174,4.67-5.367c9.045-0.629,18.144-0.789,27.158-0.476c2.777,0.097,4.95,2.425,4.853,5.2 c-0.095,2.775-2.459,4.927-5.2,4.853c-8.662-0.303-17.414-0.147-26.114,0.46C1788.49,1202.6,1788.371,1202.603,1788.255,1202.603 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE41A4"
    },
    d: "M1855.451,1206.877c-0.327,0-0.661-0.033-0.995-0.1c-4.292-0.863-8.646-1.616-12.94-2.242 c-2.749-0.4-4.654-2.952-4.254-5.701c0.398-2.749,2.943-4.657,5.702-4.254c4.474,0.65,9.007,1.436,13.474,2.333 c2.725,0.548,4.488,3.199,3.941,5.922C1859.898,1205.225,1857.797,1206.877,1855.451,1206.877z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008138221775926836360000004884863426237044415_",
    gradientUnits: "userSpaceOnUse",
    x1: -4003.3328,
    y1: 5465.374,
    x2: -4220.1685,
    y2: 5756.6465,
    gradientTransform: "matrix(0.1849 -0.9827 -0.9827 -0.1849 8121.6797 -1713.5302)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008138221775926836360000004884863426237044415_)"
    },
    d: "M1880.754,1255.129 c0,0,19.753,118.635-65.771,142.529c-85.524,23.895-177.742,26.775-198.432,63.086c0,0,6.125-235.096,239.867-240.37 L1880.754,1255.129z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104703378821708032020000003208938716556339853_",
    gradientUnits: "userSpaceOnUse",
    x1: 2271.5378,
    y1: 774.8199,
    x2: 1743.3992,
    y2: 2243.551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104703378821708032020000003208938716556339853_)"
    },
    d: "M2132.474,1227.146 c0,0,58.952,102.308,37.903,136.348c-20.02,32.379-247.229,173.25-269.354,186.921c-0.995,0.614-2.263,0.341-2.953-0.603l0,0 c-5.713-7.807-7.362-17.839-4.429-27.058c14.168-44.524,57.605-177.102,83.596-212.977 C2008.626,1266.453,2132.474,1227.146,2132.474,1227.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1973.068,1486.94c0.705,0.181,1.482,0.079,2.144-0.346c1.239-0.799,124.338-80.102,175.998-116.3 c9.2-6.443,13.739-17.711,11.569-28.701c-3.424-17.332-11.186-51.051-24.707-82.131c-0.598-1.368-2.191-2.007-3.572-1.404 c-1.375,0.599-2.004,2.2-1.407,3.573c13.319,30.61,20.98,63.895,24.359,81.012c1.757,8.885-1.915,17.991-9.357,23.205 c-51.573,36.139-174.584,115.387-175.819,116.181c-1.261,0.81-1.624,2.49-0.814,3.755 C1971.846,1486.38,1972.429,1486.776,1973.068,1486.94z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072281374423479017930000008144143302676753294_",
    gradientUnits: "userSpaceOnUse",
    x1: 1984.7441,
    y1: 501.2953,
    x2: 1456.6061,
    y2: 1970.0242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072281374423479017930000008144143302676753294_)"
    },
    d: "M1970.468,1005.776 c0,0-79.689-87.133-118.499-77.365c-36.917,9.291-239.907,183.255-259.629,200.209c-0.887,0.763-1.009,2.053-0.318,2.998l0,0 c5.713,7.806,14.777,12.411,24.451,12.404c46.724-0.037,186.231-1.345,228.287-15.27 C1895.546,1111.938,1970.468,1005.776,1970.468,1005.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1676.659,1081.928c0.814,0.208,1.711,0.04,2.408-0.536 c1.134-0.94,113.872-94.223,163.917-132.451c7.221-5.517,17.011-6.258,24.948-1.904c15.295,8.4,44.71,25.775,69.851,47.722 c1.12,0.999,2.843,0.872,3.829-0.259c0.984-1.126,0.87-2.841-0.262-3.828c-24.244-21.169-51.885-38.001-70.805-48.394 c-9.819-5.389-21.928-4.472-30.855,2.347c-50.132,38.294-162.95,131.648-164.085,132.583c-1.154,0.957-1.315,2.667-0.36,3.821 C1675.626,1081.487,1676.125,1081.79,1676.659,1081.928z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058555872426932371510000005894321191658506672_",
    gradientUnits: "userSpaceOnUse",
    x1: 3067.4712,
    y1: 6824.9639,
    x2: 3219.4561,
    y2: 8355.6572,
    gradientTransform: "matrix(-0.982 -0.1888 -0.1888 0.982 6482.6909 -5228.0415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058555872426932371510000005894321191658506672_)"
    },
    d: "M2451.61,991.701 c-33.529,46.603-77.159,93.772-133.807,135.481c-175.873,129.495-327.538,194.256-371.154,211.517 c-7.888,3.122-16.81,1.581-23.334-3.844c-51.41-42.752-90.137-94.868-116.256-156.293c-4.914-11.555-2.868-24.921,5.147-34.588 c34.78-41.945,140.585-161.68,309.594-284.614c56.456-41.066,114.161-68.291,168.361-86.164 C2378.504,842.682,2427.132,936.803,2451.61,991.701z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124844803100221682650000012299753731444307610_",
    gradientUnits: "userSpaceOnUse",
    x1: 2290.1626,
    y1: 866.283,
    x2: 2556.8594,
    y2: 866.283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124844803100221682650000012299753731444307610_)"
    },
    d: "M2290.163,773.196 c119.724-39.476,222.334-33.283,256.523-29.582c6.682,0.722,11.275,6.997,9.943,13.586 c-6.79,33.59-31.774,132.696-105.019,234.501C2427.132,936.803,2378.504,842.682,2290.163,773.196z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181047663043083004960000011244500661807241860_",
    gradientUnits: "userSpaceOnUse",
    x1: 2519.2078,
    y1: 6938.8066,
    x2: 2733.1836,
    y2: 6938.8066,
    gradientTransform: "matrix(-0.9685 -0.2488 -0.2488 0.9685 6501.3594 -5081.8857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181047663043083004960000011244500661807241860_)"
    },
    d: "M2166.588,896.235 c-45.651,33.41-53.592,100.214-17.733,149.211c35.857,48.997,101.935,61.632,147.586,28.222 c45.651-33.41,53.591-100.213,17.734-149.21C2278.316,875.46,2212.24,862.825,2166.588,896.235z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003086393166612832510000006376880442232592004_",
    gradientUnits: "userSpaceOnUse",
    x1: -1122.811,
    y1: 5443.1069,
    x2: -947.6078,
    y2: 5443.1069,
    gradientTransform: "matrix(-0.5905 -0.807 -0.807 0.5905 6013.3062 -3068.7915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003086393166612832510000006376880442232592004_)"
    },
    d: "M2180.277,910.086 c-36.377,26.621-42.704,79.852-14.131,118.893c28.572,39.041,81.223,49.11,117.6,22.488 c36.375-26.621,42.701-79.851,14.13-118.892C2269.303,893.533,2216.652,883.465,2180.277,910.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2280.493,1021.32c1.032,0.265,2.169-0.094,2.849-1.004c17.359-23.222,17.018-56.47-0.829-80.862 c-4.498-6.141-9.874-11.473-15.979-15.85c-1.213-0.881-2.911-0.594-3.787,0.626c-0.872,1.215-0.595,2.912,0.624,3.783 c5.639,4.042,10.606,8.975,14.76,14.65c16.454,22.479,16.808,53.076,0.864,74.402c-0.897,1.203-0.653,2.903,0.549,3.797 C2279.836,1021.086,2280.159,1021.234,2280.493,1021.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179609781263609916480000000472561637044093075_",
    gradientUnits: "userSpaceOnUse",
    x1: 2686.1704,
    y1: 7097.8994,
    x2: 2827.531,
    y2: 7097.8994,
    gradientTransform: "matrix(-0.9685 -0.2488 -0.2488 0.9685 6501.3594 -5081.8857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179609781263609916480000000472561637044093075_)"
    },
    d: "M2022.5,1047.917 c-30.159,22.071-35.405,66.204-11.716,98.573c23.69,32.37,67.342,40.717,97.502,18.645 c30.159-22.071,35.404-66.204,11.715-98.574C2096.311,1034.193,2052.659,1025.845,2022.5,1047.917z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041986756174697982040000012534564022555221905_",
    gradientUnits: "userSpaceOnUse",
    x1: -1094.141,
    y1: 5649.9424,
    x2: -978.3962,
    y2: 5649.9424,
    gradientTransform: "matrix(-0.5905 -0.807 -0.807 0.5905 6013.3062 -3068.7915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041986756174697982040000012534564022555221905_)"
    },
    d: "M2031.543,1057.067 c-24.031,17.587-28.211,52.752-9.336,78.545c18.876,25.792,53.659,32.444,77.69,14.856 c24.032-17.587,28.211-52.753,9.335-78.545C2090.357,1046.131,2055.574,1039.479,2031.543,1057.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2097.519,1131.444c1.032,0.265,2.17-0.094,2.849-1.003c11.71-15.66,11.49-38.079-0.54-54.513 c-3.026-4.138-6.648-7.733-10.767-10.679c-1.208-0.88-2.909-0.595-3.786,0.625c-0.872,1.22-0.592,2.912,0.629,3.784 c3.647,2.612,6.856,5.801,9.544,9.474c10.634,14.531,10.87,34.289,0.574,48.057c-0.898,1.203-0.653,2.903,0.549,3.796 C2096.862,1131.209,2097.185,1131.358,2097.519,1131.444z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098941123513363901180000015283455799371696281_",
    gradientUnits: "userSpaceOnUse",
    x1: 1788.0652,
    y1: 3117.7109,
    x2: 1248.844,
    y2: 3704.2327
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098941123513363901180000015283455799371696281_)"
    },
    d: "M1617.617,3161.403 c0,0-5.584,31.614-8.322,62.907c-1.07,12.231,8.359,22.85,20.626,23.361c41.674,1.736,130.818,5.111,162.806,3.683 c4.808-0.215,7.953-5.137,6.173-9.61c-1.491-3.748-4.368-6.778-8.032-8.462l-147.249-67.676L1617.617,3161.403z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183220313781322156700000009753506686960855463_",
    gradientUnits: "userSpaceOnUse",
    x1: 1613.0422,
    y1: 3161.2729,
    x2: 1660.9385,
    y2: 3161.2729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183220313781322156700000009753506686960855463_)"
    },
    d: "M1613.042,3142.828l4.486,37.814 c0,0,25.794,12.007,43.41-1.514l-10.682-42.14L1613.042,3142.828z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101822676842396592120000012650489452728467629_",
    gradientUnits: "userSpaceOnUse",
    x1: 1499.469,
    y1: 2795.043,
    x2: 1657.8378,
    y2: 2795.043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101822676842396592120000012650489452728467629_)"
    },
    d: "M1616.414,2431.91 c-1.938,9.875-10.403,492.783,41.217,709.19c0.842,3.531-0.948,7.17-4.309,8.544c-7.918,3.235-23.438,7.919-42.04,8.544 c-5.761,0.193-10.925-3.551-12.55-9.08c-14.756-50.21-85.46-301.775-94.683-542.089c-10.306-268.527,0-9.143,0-9.143 l6.045-165.987L1616.414,2431.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067937006995645980860000001488301763335809419_",
    gradientUnits: "userSpaceOnUse",
    x1: 1667.0997,
    y1: 3006.501,
    x2: 1127.8789,
    y2: 3593.0225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067937006995645980860000001488301763335809419_)"
    },
    d: "M1448.232,3177.896 c0,0-8.889,15.96-17.495,58.369c-1.554,7.659,3.797,14.989,11.574,15.754c13.76,1.353,34.945,3.093,51.915,2.976 c7.823-0.054,13.928-6.865,12.985-14.631c-1.88-15.48-7.735-40.876-25.825-60.671L1448.232,3177.896z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002353322846089250470000004765335078795873967_",
    gradientUnits: "userSpaceOnUse",
    x1: 1440.425,
    y1: 3158.8164,
    x2: 1481.7791,
    y2: 3158.8164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002353322846089250470000004765335078795873967_)"
    },
    d: "M1440.425,3129.259l10.483,57.185 c0,0,10.365,7.71,30.871,2.121l-5.004-61.528L1440.425,3129.259z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018211926523297880060000012362239000775558288_",
    gradientUnits: "userSpaceOnUse",
    x1: 1395.8517,
    y1: 2789.8611,
    x2: 1620.6841,
    y2: 2789.8611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018211926523297880060000012362239000775558288_)"
    },
    d: "M1412.104,2446.729 c-42.217,254.786,9.158,629.725,26.485,703.11c1.061,4.492,4.687,7.935,9.24,8.69c7.734,1.282,20.468,2.328,33.021-1.318 c4.325-1.256,7.364-5.157,7.54-9.658c2.324-59.329-1.86-423.553,37.478-567.496c1.994-7.295,6.449-13.656,12.612-18.038 l76.351-54.279l5.854-87.737L1412.104,2446.729z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114075978230307418510000001605398061641853360_",
    gradientUnits: "userSpaceOnUse",
    x1: 1331.9177,
    y1: 2358.6787,
    x2: 2085.5674,
    y2: 1816.3024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114075978230307418510000001605398061641853360_)"
    },
    d: "M1681.115,1963.959 c-126.518-2.091-266.117,33.22-266.117,33.22c-37.712,220.051-6.594,473.864-6.594,473.864 c97.947,25.686,208.437-15.704,208.437-15.704c16.28-91.976,92.235-350.827,92.235-350.827 c61.817-7.672,112.74-25.507,154.676-49.086c-31.988-37.079-47.068-84.259-53.618-112.149 C1765.403,1957.178,1720.138,1964.604,1681.115,1963.959z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018220420797103360750000005092398622599892623_",
    gradientUnits: "userSpaceOnUse",
    x1: 1810.1346,
    y1: 1911.7203,
    x2: 2054.8279,
    y2: 1911.7203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018220420797103360750000005092398622599892623_)"
    },
    d: "M2054.828,1777.604 c-12.429-15.011-28.158-7.91-28.158-7.91c-18.619,78.646-116.241,142.413-216.535,173.582 c6.55,27.89,21.63,75.07,53.618,112.149C2030.198,1961.839,2054.828,1777.604,2054.828,1777.604z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142138477519150327520000003692670085724753845_",
    gradientUnits: "userSpaceOnUse",
    x1: 8447.46,
    y1: 1870.7042,
    x2: 8611.6553,
    y2: 2244.2854,
    gradientTransform: "matrix(-1 0 0 1 10447.7783 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142138477519150327520000003692670085724753845_)"
    },
    d: "M2051.811,1781.422 c1.301,4.134-13.759,10.429-22.626-6.479c-0.31-8.104-5.238-42.821-0.396-49.423c25.79-35.161,75.792-79.236,75.792-79.236 c8.45,8.338,1.488,16.53,1.488,16.53l-24.256,25.268c5.073,9.168,11.262,16.907,14.162,27.997 c2.197,8.398,0.853,17.373-3.389,25.016c-4.258,7.671-10.067,17.642-15.558,25.446 C2066.633,1781.31,2051.811,1781.422,2051.811,1781.422z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125585980011145891730000004512725838902928769_",
    gradientUnits: "userSpaceOnUse",
    x1: 2053.6533,
    y1: 1746.2881,
    x2: 2122.1648,
    y2: 1640.9515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125585980011145891730000004512725838902928769_)"
    },
    d: "M2071.203,1704.477l-22.104,18.738 l-6.94,18.657l19.708,21.863c0,0,6.626-37.017,11.552-45.03C2078.344,1710.694,2075.79,1706.82,2071.203,1704.477z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027564394067900548210000004783251858924653963_",
    gradientUnits: "userSpaceOnUse",
    x1: 1232.6069,
    y1: 2220.6838,
    x2: 1986.255,
    y2: 1678.3086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027564394067900548210000004783251858924653963_)"
    },
    d: "M1463.526,2119.685l-48.527-122.507 c0,0-118.174,80.295-137.609,182.1c22.329,1.644,62.961,7.452,102.731,27.534 C1388.86,2158.742,1463.526,2119.685,1463.526,2119.685z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111887954383844812830000015502039564519287950_",
    gradientUnits: "userSpaceOnUse",
    x1: 1274.6956,
    y1: 2258.3215,
    x2: 1584.3569,
    y2: 2258.3215
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111887954383844812830000015502039564519287950_)"
    },
    d: "M1566.798,2234.96 c0,0-132.681,74.985-177.449,10.957c-9.295-13.295-11.517-26.508-9.228-39.104c-39.771-20.082-80.402-25.889-102.731-27.534 c-5.86,30.69-2.762,63.332,15.272,96.323c78.419,143.451,291.695-7.928,291.695-7.928L1566.798,2234.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039845253269733092780000005360954314144491174_",
    gradientUnits: "userSpaceOnUse",
    x1: 1610.959,
    y1: 2328.0178,
    x2: 1875.4875,
    y2: 1863.8905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039845253269733092780000005360954314144491174_)"
    },
    d: "M1550.856,2329.823l72.412-252.879 c0.822-2.871,3.271-4.964,6.237-5.31c13.12-1.531,51.136-5.828,95.03-9.541c52.871-4.472,114.27-8.096,150.96-5.014 c5.216,0.438,8.368,5.955,6.048,10.648c-20.864,42.211-106.686,213.916-149.664,270.164c-1.424,1.864-3.626,2.953-5.971,2.931 l-168.008-1.563C1553.012,2339.214,1549.51,2334.524,1550.856,2329.823z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063611760312329512760000016889562853970895799_",
    gradientUnits: "userSpaceOnUse",
    x1: 1769.2389,
    y1: 1993.9905,
    x2: 1732.9756,
    y2: 2153.2334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063611760312329512760000016889562853970895799_)"
    },
    d: "M1732.045,2040.17l52.5-8.748 c2.796-0.466,5.086,2.206,4.198,4.897l-5.197,15.748c-0.453,1.371-1.649,2.363-3.08,2.554l-50.521,6.749 c-2.614,0.349-4.769-2.026-4.168-4.593l3.217-13.749C1729.343,2041.547,1730.546,2040.419,1732.045,2040.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074442938124809755230000006031969812389460923_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.9484,
    y1: 2027.4457,
    x2: 1742.605,
    y2: 2131.5059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074442938124809755230000006031969812389460923_)"
    },
    d: "M1692.735,2084.615l4.325-22.528 c0.434-2.26,2.3-3.967,4.588-4.199l106.038-10.76c3.569-0.363,6.427,2.909,5.589,6.397l-6.742,28.072 c-0.54,2.246-2.494,3.868-4.802,3.985l-103.621,5.217C1694.738,2090.967,1692.098,2087.932,1692.735,2084.615z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049186036941857814360000016519409427071656880_",
    gradientUnits: "userSpaceOnUse",
    x1: 1561.3658,
    y1: 2225.8535,
    x2: 1657.8378,
    y2: 2225.8535
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049186036941857814360000016519409427071656880_)"
    },
    d: "M1568.351,2268.728 c0,0-10.087-41.477-6.018-56.193c4.068-14.716,11.952-33.636,38.23-29.431c26.278,4.205,57.275,15.274,57.275,15.274 s-1.566,19.167-21.537,12.984l12.384,9.583c0,0-1.77,15.347-18.64,7.148l11.519,12.709c0,0-7.245,12.604-19.656,4.52 S1603.548,2273.722,1568.351,2268.728z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146465294202520569770000002184293840814474134_",
    gradientUnits: "userSpaceOnUse",
    x1: 1512.4722,
    y1: 1927.2748,
    x2: 1634.9023,
    y2: 1927.2748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146465294202520569770000002184293840814474134_)"
    },
    d: "M1552.963,1861.246l-40.256,116.418 c-0.667,1.928,0.126,4.064,1.912,5.052c10.974,6.067,50.508,23.604,98.151-6.603c4.963-3.147,8.342-8.278,9.096-14.107 l13.036-100.759H1552.963z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000913726689461842190000003228175134695438987_",
    gradientUnits: "userSpaceOnUse",
    x1: -4349.4927,
    y1: -326.7661,
    x2: -4395.2432,
    y2: -477.6628,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000913726689461842190000003228175134695438987_)"
    },
    d: "M1640.555,1753.439 c0,0,44.206,83.211,38.539,116.825c-5.666,33.614-60.452,31.2-108.293,3.901l-33.43-89.851L1640.555,1753.439z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111895055205383548930000001459825010008508347_",
    gradientUnits: "userSpaceOnUse",
    x1: -4390.7686,
    y1: -589.6807,
    x2: -4352.4985,
    y2: -371.3994,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111895055205383548930000001459825010008508347_)"
    },
    d: "M1572.915,1830.039 c1.944-0.861,2.662-3.24,1.497-5.019c-3.541-5.41-10.18-16.448-12.298-26.112c0,0-7.947-5.09,20.226-11.833 c28.173-6.744,70.186-17.21,79.017-41.191c8.61-23.38-14.012-82.178-50.103-35.329c-1.373,1.783-4.063,1.822-5.434,0.038 c-5.917-7.701-21.471-23.684-43.067-13.994c-20.209,9.068-22.486,23.876-22.208,31.341c0.082,2.196-1.881,3.903-4.039,3.491 c-10.219-1.948-34.737-3.622-46.182,21.531c-9.427,20.718-3.3,32.446,2.28,38.182c1.808,1.858,1.016,4.918-1.463,5.677 c-6.716,2.055-15.387,7.75-14.519,23.483c1.201,21.75,25.518,19.834,32.442,18.842c1.134-0.163,2.277,0.227,3.045,1.077 c5.937,6.569,32.684,34.465,61.632,37.827c2.507,0.291,4.449-2.185,3.628-4.571l-12.528-36.417 c-0.582-1.692,0.227-3.547,1.863-4.271L1572.915,1830.039z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140008779912690912830000018199084941010567615_",
    gradientUnits: "userSpaceOnUse",
    x1: -4396.2603,
    y1: -327.4679,
    x2: -4437.4233,
    y2: -463.2333,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140008779912690912830000018199084941010567615_)"
    },
    d: "M1577.951,1835.208 c0,0-31.475-21.595-33.774-3.409c-2.3,18.185,28.343,26.341,43.521,19.561L1577.951,1835.208z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.f086897eddb8df663242aba6197c8eca.svg";
export { ForwardRef as ReactComponent };